import { render, staticRenderFns } from "./ReceiverOrgListPage.vue?vue&type=template&id=1728a492&"
import script from "./ReceiverOrgListPage.vue?vue&type=script&lang=js&"
export * from "./ReceiverOrgListPage.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverOrgListPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports